export default class NeoleapResponseUtil {
  private static map: Map<string, string> = new Map();

  public static respCodeWithErrorMsg(key: string): string | undefined {
    if (!this.map.has(key)) {
      this.map.set("01", "Completed – transaction declined for different reasons (including invalid PIN), account not debited.");
      this.map.set("02", "Completed – transaction rejected, account not debited.");
      this.map.set("11", "Cancelled by user, account not debited.");
      this.map.set("12", "Void due to communication failure or some other reason, account not debited.");
      this.map.set("13", "Card Not Supported");
      this.map.set("14", "Transaction Not allowed");
      this.map.set("15", "Expired Card");
      this.map.set("16", "No Dial Tone (Phone line disconnected)");
      this.map.set("17", "Card is not accepted.");
      this.map.set("86", "Incorrect Refund Card");
      this.map.set("87", "PIN locked.");
      this.map.set("88", "PIN timeout.");
      this.map.set("89", "Service is not accepted.");
      this.map.set("90", "Card removed after PIN entry.");
      this.map.set("91", "Card removed Before PIN entry");
      this.map.set("92", "Card removed after sending request (ARQC check failed).");
      this.map.set("93", "Card Timeout.");
      this.map.set("94", "Invalid PIN.");
      this.map.set("95", "Invalid Amount.");
      this.map.set("96", "Invalid Card (Blocked Card)");
      this.map.set("97", "EMV Application is Blocked");
      this.map.set("98", "Transaction declined by Card");
      this.map.set("99", "EMV Card not Detected by POS (Card not inserted into POS)");
    }
    return this.map.get(key);
  }
}
